import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined'
import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { File } from '@/shared/assets/icons'
import { PERMISSION_SUB_MODULES } from '@/shared/const'
import { PageWrapper } from '@/shared/ui/page-wrapper'
import { PermissionGuard } from '@/shared/ui/permission-guard'
import { CustomTab } from '@/shared/ui/tab'
import { CustomTabs } from '@/shared/ui/tabs'

type RouteName = 'processes' | 'queue'

export const Route = createFileRoute('/_auth/administration/monitoring')({
  staticData: {
    meta: {
      title: 'Мониторинг',
      description: '',
    },
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation()

  const navigate = useNavigate()

  const handleTabChange = (value: RouteName) => {
    setTab(value)
    navigate({ to: `/administration/monitoring/${value}` })
  }

  const [tab, setTab] = useState<RouteName>('processes')

  return (
    <PermissionGuard permission={PERMISSION_SUB_MODULES.MONITORING}>
      <PageWrapper title={t('Мониторинг')}>
        <CustomTabs value={tab} onChange={(_, value) => handleTabChange(value)}>
          <CustomTab
            value="processes"
            icon={<File fontSize="small" />}
            iconPosition="start"
            label={t('Процессы/Заявки')}
          />
          <CustomTab
            value="queue"
            icon={<WarningAmberOutlinedIcon fontSize="small" />}
            iconPosition="start"
            label={t('Очередь ошибок')}
          />
        </CustomTabs>
        <Outlet />
      </PageWrapper>
    </PermissionGuard>
  )
}
